const PATTERN_VALIDATION = {
  email: /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/,
  emailEdu: /^[a-zA-Z0-9_][a-zA-Z0-9_.+-]{1,32}@[A-Za-z0-9.-]+\.edu(\.[A-Z|a-z]{2,7})?$/,
  phone: /^([+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b$/,
  vietnameseName: /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s\w|_]+$/,
  taxCode: /^[A-Za-z0-9]{10}(-[A-Za-z0-9]{3})?$/,
  newTaxCode: /^([A-Za-z0-9]{10}(-[A-Za-z0-9]{3})?|[0-9]{12})$/,
  citizenIdNumber: /^(\d{9}|\d{12})$/,
  stateBudgetUnitCode: /^\d{7}$/
};
const isValidEmailFormat = (email) => {
  return PATTERN_VALIDATION.email.test(email);
};
const isValidPhoneFormat = (number) => {
  return !!number.match(/^((\+84|0)(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})$/);
};
const isValidTaxCode = (code) => {
  return PATTERN_VALIDATION.taxCode.test(code);
};
const isValidNewTaxCode = (code) => {
  return PATTERN_VALIDATION.newTaxCode.test(code);
};
const isValidCitizenIdNumber = (code) => {
  return PATTERN_VALIDATION.citizenIdNumber.test(code);
};
const isValidPassportNumber = (code) => {
  return code !== "" && code.length <= 20;
};
const isValidStateBudgetUnitCode = (code) => {
  return PATTERN_VALIDATION.stateBudgetUnitCode.test(code);
};

export { PATTERN_VALIDATION, isValidCitizenIdNumber, isValidEmailFormat, isValidNewTaxCode, isValidPassportNumber, isValidPhoneFormat, isValidStateBudgetUnitCode, isValidTaxCode };
